module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-radiobutton p-component",
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": _vm.onClick,
      "focus": function($event) {
        return _vm.onFocus($event)
      },
      "blur": function($event) {
        return _vm.onBlur($event)
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
        return _vm.onClick.apply(null, arguments)
      }
    }
  }, [_c('div', {
    ref: "box",
    class: ['p-radiobutton-box p-component', {
      'p-highlight': _vm.checked,
      'p-disabled': _vm.disabled,
      'p-focus': _vm.focused
    }],
    attrs: {
      "role": "radio",
      "aria-checked": _vm.checked
    }
  }, [_c('div', {
    staticClass: "p-radiobutton-icon"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e4b47f20"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/primevue/datatable/RowRadioButton.vue
// module id = 2428
// module chunks = 0